var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__content"},[_c('h3',[_vm._v("7. "+_vm._s(_vm.$t('notaBene.title')))]),_c('div',{staticClass:"form__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }